import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { clearTicket, updateTicket, fetchEvent, clearEvent, deleteTicket } from '../../eventActions';

import EventAdminCampaignTicketList from './EventAdminCampaignTicketList';

const mapStateToProps = state => ({
  campaignId: get(state, 'campaign.campaign.id'),
  tickets: get(state, 'Event.tickets'),
  locale: get(state, 'session.language'),
  eventEndOn: get(state, 'Event.event.endOn'),
  isDeleteTicketInProgress: get(state, 'Event.isDeleteTicketInProgress')
});

const mapDispatchToProps = dispatch => bindActionCreators({
  clearTicket,
  updateTicket,
  fetchEvent,
  clearEvent,
  deleteTicket
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EventAdminCampaignTicketList);
